import { laceParts1, laceParts2, laceParts3, laceParts4, laceParts5 } from './parts/laceParts'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartsOfWeb, verticalPartsOfWebWithCenterStitch } from './parts/verticalParts'

export const crossWebWithHalfNetLace = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWebWithCenterStitch(ctx, web2Color, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 左半分レース
  laceParts2(ctx, laceColor, 29, 60) // 上1
  laceParts2(ctx, laceColor, 37, 80) // 上2
  laceParts2(ctx, laceColor, 45, 100) // 上3
  laceParts1(ctx, laceColor, 45, 75) // 上2
  laceParts1(ctx, laceColor, 32, 50) // 上1

  // 右半分レース
  laceParts3(ctx, laceColor, 17, 49) // 上1
  laceParts3(ctx, laceColor, 25, 73) // 上2
  laceParts3(ctx, laceColor, 33, 90) // 上3
  laceParts4(ctx, laceColor, 21, 57) // 上1
  laceParts4(ctx, laceColor, 29, 80) // 上2
  laceParts4(ctx, laceColor, 37, 100) // 上3
  laceParts5(ctx, laceColor, 21, 58) // 上1
  laceParts5(ctx, laceColor, 29, 83) // 上2
  laceParts5(ctx, laceColor, 37, 111) // 上3

  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

export const crossWebWithHalfNetLaceAroundStitch = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, web2Color, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 左半分レース
  laceParts2(ctx, laceColor, 29, 60) // 上1
  laceParts2(ctx, laceColor, 37, 80) // 上2
  laceParts2(ctx, laceColor, 45, 100) // 上3
  laceParts1(ctx, laceColor, 45, 75) // 上2
  laceParts1(ctx, laceColor, 32, 50) // 上1

  // 右半分レース
  laceParts3(ctx, laceColor, 17, 49) // 上1
  laceParts3(ctx, laceColor, 25, 73) // 上2
  laceParts3(ctx, laceColor, 33, 90) // 上3
  laceParts4(ctx, laceColor, 21, 57) // 上1
  laceParts4(ctx, laceColor, 29, 80) // 上2
  laceParts4(ctx, laceColor, 37, 100) // 上3
  laceParts5(ctx, laceColor, 21, 58) // 上1
  laceParts5(ctx, laceColor, 29, 83) // 上2
  laceParts5(ctx, laceColor, 37, 111) // 上3

  // ウェブ_横＿中間
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}
